// extracted by mini-css-extract-plugin
export default {"left":"Heading_left__PIYmT","under":"Heading_under__JfRfR"};